import $ from 'jquery';
import * as L from 'leaflet';

let Locator = {
    $el: null,
    $zipInput: null,
    $zipBtn: null,
    $locatorResults: null,
    $zipForm: null,
    $loadMoreButton: null,
    $errorText: null,
    map: null,
    myIcon: null,
    currentZipCode: null,
    currentResultPage: null,
    hasResults: true,
    latitude: null,
    longitude: null
};
Locator.attach = function ($locator) {
    this.$el = $locator;
    this.$zipInput = $locator.find('input.distributorZip');
    this.$zipSubmitBtn = $locator.find('#dl_submit');
    this.$zipClrBtn = $locator.find('#dl_clear');
    this.$locatorResults = $locator.find('#results-locations');
    this.$errorText = $locator.find('#locator-error');
    this.map = new L.Map('distMapView');
    this.myIcon = new L.divIcon('distMapView');
    this.$zipForm = $locator.find('.zipForm');
    this.$geolocate = $locator.find('#geoocate');
    this.$geolocateLoading = $locator.find('#geolocate-loading');
    this.$loadMoreButton = $locator.find('#load-more');
    this.$loadMoreLoading = $locator.find('#load-more-loading');
    const locator = this;

    this.currentZipCode = $.trim(this.$zipInput[0].value);
    // The first page is rendered server-side into #results-locations.
    this.currentResultPage = 1;
    this.$loadMoreButton.toggle(takeHasMoreFlag(this.$locatorResults));

    // geolocate on page loading
    locate();

    this.$zipForm.on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.$errorText.hide();
        this.currentZipCode = $.trim(this.$zipInput[0].value);
        this.latitude = null;
        this.longitude = null;
        startNewSearch();
    }.bind(this));

    this.$loadMoreButton.on('click', function() {
        loadMoreResults();
    });

    /**
     * Reads the marker the server appends to every page of results, then takes
     * it back out so it never shows up in the list.
     */
    function takeHasMoreFlag($container) {
        const $flag = $container.find('[data-has-more]');
        const hasMore = $flag.attr('data-has-more') === '1';
        $flag.remove();

        return hasMore;
    }

    let startNewSearch = function () {
        this.currentResultPage = 0;
        this.$locatorResults.empty();
        loadMoreResults();
    }.bind(this);

    let loadMoreResults = function() {
        this.$loadMoreButton.hide();
        this.$loadMoreLoading.show();

        const data = {page: this.currentResultPage + 1};

        // A GPS fix goes straight to the coordinate query; only a typed search
        // needs the server to geocode anything.
        if (this.latitude !== null && this.longitude !== null) {
            data.latitude = this.latitude;
            data.longitude = this.longitude;
        } else if (this.currentZipCode) {
            data.zip = this.currentZipCode;
        }

        $.ajax({
            method: "GET",
            url: "/ajax/locator",
            data: data
        }).done(function (resp) {
            this.$loadMoreLoading.hide();

            const $incoming = $('<div>').html(resp);
            const hasMore = takeHasMoreFlag($incoming);

            this.$locatorResults.append($incoming.children());
            this.currentResultPage++;
            initlayerGroupMap();
            this.$zipForm.addClass('clrBtn-active');
            this.$zipInput.prop('disabled', true);

            this.hasResults = this.$locatorResults.find('li').length > 0;
            this.$loadMoreButton.toggle(hasMore);

            if (this.hasResults) {
                this.$el.find('#zipResultNone').remove();
            } else if (!this.$el.find('#zipResultNone').length) {
                this.$el.find('.zipFilter').next().append('<p id="zipResultNone"><i>No results found!</i></p>');
            }
        }.bind(this)).fail(function () {
            this.$loadMoreLoading.hide();
            this.$loadMoreButton.show();
            this.$errorText.show();
        }.bind(this));
    }.bind(this);

    this.$zipInput.on('input', function () {
      let zipVal = this.$zipInput[0].value;
        if (zipVal.length > 0) {
            this.$zipSubmitBtn.text('SUBMIT');
            this.$zipSubmitBtn.removeAttr('disabled');
            this.$zipForm.removeClass('clrBtn-active');
        }
        else {
            this.$zipSubmitBtn.attr('disabled', 'disabled');
        }
    }.bind(this));

    // Clear zip
    this.$zipClrBtn.on('click', function () {
        $('.distributorZip').prop('disabled', false).val('').focus();
    });

    var initClickHandlers = function() {
        $('[data-distributor-location]').on('click', function () {
            const newData = $(this).data();
            mapData(newData);
        });
    };

    $.fn.reverse = function() {
        return this.pushStack(this.get().reverse(), arguments);
    };

    function initlayerGroupMap() {
        $('[data-distributor-location]').reverse().each(function () {
            const newData = $(this).data();
            mapData(newData);
        });
        initClickHandlers();
    }

    let mapMarker = function (lat, lng, no) {
        this.myIcon = L.divIcon({
            className: 'rollex-map-marker',
            iconSize: [37, 37],
            html: no
        });
        L.marker([lat, lng], {icon: this.myIcon}).addTo(this.map)
            .openPopup();
    }.bind(this);


    let updateDistMap = function (data) {
        let lt, lg, no;
        this.map.setView([data.lat, data.lng], 14.5);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="http://openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
        lt = data.lat;
        lg = data.lng;
        no = data.number;
        mapMarker(lt, lg, no);
    }.bind(this);

    /**
     * Geolocation Success
     * This gets called when getCurrentPosition() is successful.
     *
     * The coordinates go straight to the server, which searches by distance
     * from them. This used to round-trip through the Google Maps JS API to turn
     * the fix into a ZIP first, which needed a browser-exposed API key and was
     * less accurate than the fix it started from.
     */
    function geolocateSuccess(position) {
        locator.latitude = position.coords.latitude;
        locator.longitude = position.coords.longitude;
        locator.currentZipCode = null;

        $('#geolocate-loading').hide();
        $('#geoocate').show();

        startNewSearch();
    }

    /**
     * Geolocation Failure
     * This gets called when getCurrentPosition() fails (User denies geolocation mainly).
     */
    function geolocateFailure(error) {
        // This commented area is helpful during development:
        /* console.log(error);
        const errorText = $('#locator-error');
        errorText.text(error.message);
        errorText.show(); */

        $('#geolocate-loading').hide();
        $('#geoocate').show();
    }

    /**
     * Main Geolocation Initializer
     */
    function locate() {
      if(navigator.geolocation) {
        $('#locator-error').hide();
        $('#geolocate-loading').show();
        $('#geoocate').hide();
        navigator.geolocation.getCurrentPosition(geolocateSuccess, geolocateFailure);
      }
    }

    // manually geolocate user
    this.$geolocate.on('click', function () {
        locate();
    });

    this.$locatorResults.on('click', '.location', function () {
      $(this).parent().addClass('current').siblings().removeAttr('class');
    });

    function mapData(data) {
        return updateDistMap({
            lat: data.lat,
            lng: data.lng,
            locName: data.locationName,
            locAddress: data.locationAddress,
            locDistance: data.locationDistance,
            number: data.no
        });
    }

    $('[data-thumbdetail]').on('click', function () {
        $(this).toggleClass('show-detail');
    });


    initlayerGroupMap();
};

export default Locator;
